import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

const ACCENT = '#D4AF37';
const BG_CARD = '#0d1117';
const BORDER = 'rgba(255,255,255,0.07)';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    const params = search ? `?search=${encodeURIComponent(search)}` : '';
    api.get(`/clients${params}`).then(r => setClients(r.data)).finally(() => setLoading(false));
  }, [search]);

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  return (
    <AdminLayout>
      <div style={{ marginBottom: 20 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
          <h1 className="page-title" style={{ margin: 0 }}>Clients</h1>
          <Link to="/dash/import" style={{
            fontSize: 12, fontWeight: 700, color: '#6b7280',
            border: '1px solid rgba(255,255,255,0.08)', borderRadius: 8,
            padding: '8px 14px', textDecoration: 'none',
          }}>Import CSV</Link>
        </div>
        <p style={{ color: '#4b5563', fontSize: 12, margin: '0 0 16px' }}>{clients.length} clients</p>
        <input
          className="input"
          placeholder="Search name, phone, email…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ width: '100%', minHeight: 44, boxSizing: 'border-box' }}
        />
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '60px' }}><div className="spinner" style={{ margin: '0 auto' }} /></div>
      ) : clients.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: '60px', color: '#9ca3af' }}>No clients found</div>
      ) : (
        <>
          {/* Desktop table */}
          <div className="card admin-clients-table" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ background: '#0B1120', borderBottom: '1px solid #2a2a2a' }}>
                    {['Name', 'Phone', 'Email', 'Member Since', ''].map(h => (
                      <th key={h} style={{ padding: '14px 16px', textAlign: 'left', fontSize: '12px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clients.map((c, idx) => (
                    <tr key={c.id} style={{ borderBottom: '1px solid #2a2a2a', background: idx % 2 === 0 ? '#0F1929' : '#0B1120' }}>
                      <td style={{ padding: '14px 16px', fontWeight: 600 }}>{c.name}</td>
                      <td style={{ padding: '14px 16px', color: '#d1d5db', fontSize: '14px' }}>{c.phone || '—'}</td>
                      <td style={{ padding: '14px 16px', color: '#d1d5db', fontSize: '14px' }}>{c.email || '—'}</td>
                      <td style={{ padding: '14px 16px', color: '#9ca3af', fontSize: '13px' }}>
                        {new Date(c.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                      </td>
                      <td style={{ padding: '14px 16px' }}>
                        <Link to={`/dash/clients/${c.id}`} style={{ color: ACCENT, fontSize: '13px' }}>View →</Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Mobile cards */}
          <div className="admin-clients-cards">
            {clients.map(c => {
              const initials = c.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
              return (
                <Link key={c.id} to={`/dash/clients/${c.id}`} style={{ textDecoration: 'none' }}>
                  <div style={{
                    background: BG_CARD,
                    border: `1px solid ${BORDER}`,
                    borderRadius: 16,
                    padding: '14px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 14,
                    transition: 'border-color 0.15s',
                  }}>
                    {/* Avatar */}
                    <div style={{
                      width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
                      background: 'rgba(212,175,55,0.1)',
                      border: '1px solid rgba(212,175,55,0.25)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 14, fontWeight: 800, color: ACCENT,
                      letterSpacing: '0.02em',
                    }}>
                      {initials}
                    </div>
                    {/* Info */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700, fontSize: 15, color: '#fff', marginBottom: 2 }}>{c.name}</div>
                      <div style={{ color: '#6b7280', fontSize: 12, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {c.phone && <span>{c.phone}</span>}
                        {c.email && <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 160 }}>{c.email}</span>}
                      </div>
                    </div>
                    {/* Chevron */}
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4b5563" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
                      <path d="M9 18l6-6-6-6" />
                    </svg>
                  </div>
                </Link>
              );
            })}
          </div>
        </>
      )}
    </AdminLayout>
  );
}
